import {
  faDroplet,
  faEye,
  faTemperatureHigh,
  faWind,
} from '@fortawesome/pro-light-svg-icons';

const TABS = [
  { id: 'overview', icon: faEye, label: 'Overview' },
  {
    id: 'temperature', icon: faTemperatureHigh, label: 'Temperature', defaultRisk: 'fire', 
  },
  {
    id: 'water', icon: faDroplet, label: 'Water', defaultRisk: 'dry-spell', 
  },
  {
    id: 'wind', icon: faWind, label: 'Wind', defaultRisk: 'extreme-wind', 
  },
];

export {
  TABS,
};